import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import getPersonName from "../common/Name";
import Address from "./Address";
import getSsn from "../common/Ssn";
import { getDate, getDobDate } from "../common/DisplayDate";

class DriverLicense extends Component {
  componentDidMount() {}

  render() {
    const { node } = this.props;
    const restrictions = [];
    _.forEach(_.get(node, "restrictionsDetail[0].restriction"), (detail) => {
      const restriction = _.get(detail, "offenseDesc1[0]._", "");
      restrictions.push(restriction);
    });

    const nameNode = _.get(node, "name[0]");
    const race = _.get(node, "race[0]._", "");
    const height = _.get(node, "height[0]._", "");
    const weight = _.get(node, "weight[0]._", "");
    const eyeColor = _.get(node, "eyeColor[0]._", "");
    const hairColor = _.get(node, "hairColor[0]._", "");

    let heightText = "";

    if (height !== "") {
      heightText = `${height.substring(0, 1)}ft${height.substring(1, 3)}in `;
    }
    const physicalData = [];
    if (race !== "") {
      physicalData.push(
        <span key={`phy_data_${this.props.index}`}>Race: {race} </span>
      );
    }
    if (height !== "") {
      physicalData.push(
        <span key={`height_${this.props.index}`}>Height: {heightText} </span>
      );
    }
    if (weight !== "") {
      physicalData.push(
        <span key={`weight_${this.props.index}`}>Weight: {weight}lb </span>
      );
    }
    if (eyeColor !== "") {
      physicalData.push(
        <span key={`eye_color_${this.props.index}`}>
          <nobr>Eye Color:</nobr> {eyeColor}
        </span>
      );
    }
    if (weight !== "") {
      physicalData.push(
        <span key={`hair_color_${this.props.index}`}>
          <nobr>Hair Color:</nobr> {hairColor}
        </span>
      );
    }

    return (
      <Table
        key={`InstantCriminal_Table_${this.props.index}`}
        className={`sub-table`}
      >
        <Table.Body>
          <Table.Row>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Name:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              {nameNode &&
                getPersonName(
                  _.get(nameNode, "first[0]._", ""),
                  _.get(nameNode, "middle[0]._", ""),
                  _.get(nameNode, "last[0]._", ""),
                  this.props
                )}
            </Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Record Type:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              {_.get(node, "history[0]._", "")}
            </Table.Cell>
          </Table.Row>
          <Table.Row className={"table-no-border"}>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Address:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              <Address
                addressNode={_.get(node, "address[0]")}
                {...this.props}
              />
            </Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"}>
              License Class/Type:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"} colSpan={3}>
              {`${_.get(node, "licenseClass[0]._", "")} ${_.get(
                node,
                "licenseType[0]._",
                ""
              )} ${_.get(node, "status[0]._", "")}`}
            </Table.Cell>
          </Table.Row>
          <Table.Row className={"table-no-border"}>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Date of Birth:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              {getDobDate(_.get(node, "DOB[0]"), {
                userAccount: this.props.userAccount,
              })}
            </Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"}>
              License State:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              {_.get(node, "originStateName[0]._", "")}
            </Table.Cell>
          </Table.Row>
          <Table.Row className={"table-no-border"}>
            <Table.Cell className={"sub-table-cell text-bold"}>SSN:</Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              {getSsn(_.get(node, "SSN"), this.props)}
            </Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Issue Date:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              {getDate(_.get(node, "issueDate[0]"))}
            </Table.Cell>
          </Table.Row>
          <Table.Row className={"table-no-border"}>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Gender:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              {_.get(node, "sex[0]._", "")}
            </Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Expiration Date:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              {getDate(_.get(node, "expirationDate[0]"))}
            </Table.Cell>
          </Table.Row>
          <Table.Row className={"table-no-border"}>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Physical Data:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>{physicalData}</Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Restrictions:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              {restrictions.join(" ")}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default DriverLicense;



// WEBPACK FOOTER //
// ./src/components/searchresults/DriverLicense.js